<template>
<button
  @click="$emit('click')"
  type="button"
  class="cart-button"
  :aria-label="`Корзина${price ? ', ' + priceToText(price) : ''}`"
>
  <div class="cart-button__icon-and-badge">
    <IconBasket class="cart-button__basket-icon"/>
    <span v-if="quantity > 0" class="cart-button__badge">{{ quantity }}</span>
  </div>
  <span v-if="price" class="cart-button__price">{{ priceToText(price) }}</span>
</button>
</template>

<script>
import { mapGetters } from 'vuex'
import priceToText from '@/helpers/priceToText'

export default {
  components: {
    IconBasket: () => import(/* webpackPreload: true */ '@/assets/images/icons/icon-basket.svg?inline'),
  },
  methods: {
    priceToText,
  },
  computed: {
    ...mapGetters({
      price: 'order/totalPrice',
      quantity: 'order/totalQuantity',
    }),
  }
}
</script>

<style lang="less">
.cart-button {
  @apply flex items-center px-4;

  &:hover, &:focus {
    @apply bg-light rounded outline-none;
    color: initial;
  }

  &__icon-and-badge {
    @apply relative;
  }

  &__basket-icon {
    @apply h-5 fill-current text-primary;
  }

  &__badge {
    @apply absolute text-dark-darker text-2xs font-medium rounded-full bg-secondary h-4 border border-white
      flex items-center justify-center;
    box-sizing: content-box;
    min-width: theme('width.4');
    top: -9px;
    right: -8px;
  }

  &__price {
    @apply ml-2 font-medium;
  }
}
</style>
